/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedGroupList } from '../models/PaginatedGroupList';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GroupService {

    /**
     * @returns PaginatedGroupList
     * @throws ApiError
     */
    public static groupList({
        codeIcontains,
        limit,
        offset,
    }: {
        codeIcontains?: string,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedGroupList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/group/',
            query: {
                'code__icontains': codeIcontains,
                'limit': limit,
                'offset': offset,
            },
        });
    }

}
